import api from '../../axiosConfig'

export default{
    state: {
        isReset: false
    },
    getters:{
        ResetLoad: (state) => state.isReset
    },
    mutations: {
        ResetloadTrue: (state) => {
            state.isReset = true
        },
        ResetloadFalse: (state) => {
            state.isReset = false
        }
    },
    actions: {
        forget({commit}, email){
            return new Promise ((resolve, reject) => {
                commit('ResetloadTrue')
                let Email = {
                    email: email
                }
                api.post('/internal/v2/forget-password', Email).then(res => {
                    commit('ResetloadFalse')
                    resolve(res)
                }).catch(err => {
                    commit('ResetloadFalse')
                    reject(err)
                })
            })
        }
    },
}